import React from 'react';
import { useTranslation } from 'react-i18next';
import { FilterSheet, OptionRows, SheetSection } from 'components/mobile/filterSheet';
import { ASSIGNABLE_ROLES, MEMBER_STATUSES, STATUS_LABEL_KEYS } from './memberLabels';

interface MembersFilterSheetProps {
  open: boolean;
  onClose: () => void;
  role: string;
  onRoleChange: (role: string) => void;
  status?: string;
  onStatusChange: (status: string | undefined) => void;
  /** Members under the current filters — updates behind the sheet. */
  total: number;
}

/** Phones: the role and status filters the desktop filter line shows inline. */
export function MembersFilterSheet({ open, onClose, role, onRoleChange, status, onStatusChange, total }: MembersFilterSheetProps) {
  const { t } = useTranslation();
  const hasFilters = Boolean(role || status);

  return (
    <FilterSheet
      open={open}
      onClose={onClose}
      total={total}
      onClear={
        hasFilters
          ? () => {
              onRoleChange('');
              onStatusChange(undefined);
            }
          : undefined
      }
    >
      <SheetSection label={t('role')}>
        <OptionRows
          name={t('role')}
          options={ASSIGNABLE_ROLES.map((r) => ({ id: r.value, name: t(r.labelKey) }))}
          selected={role || undefined}
          onSelect={(id) => onRoleChange(id ?? '')}
          loading={false}
          emptyLabel=""
        />
      </SheetSection>
      <SheetSection label={t('status')}>
        <OptionRows
          name={t('status')}
          options={MEMBER_STATUSES.map((value) => ({ id: value, name: t(STATUS_LABEL_KEYS[value]) }))}
          selected={status}
          onSelect={onStatusChange}
          loading={false}
          emptyLabel=""
        />
      </SheetSection>
    </FilterSheet>
  );
}

export default MembersFilterSheet;
